import React, { useEffect, useState, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { setFormatDateMonthYear, sendDispatchEvent } from 'utils/utils';

import * as S from './style';

function SellerAchievements({ adArea, ad = {} }) {
    const [adAreaData, setAdAreaData] = useState({});

    const [hasBeenInView, setHasBeenInView] = useState(false);
    const targetRef = useRef(null);

    useEffect(() => {
        if (adArea && Object.keys(adArea).length) {
            setAdAreaData(adArea);
        }
    }, [adArea]);

  
    useEffect(() => {
      const onScroll = () => {
        if (targetRef.current) {
          const rect = targetRef.current.getBoundingClientRect();
          if (rect.top <= window.innerHeight && rect.bottom >= 10 && !hasBeenInView) {
            setHasBeenInView(true);
            sendDispatchEvent('visualizouAreaVendedor');
          }
        }
      };
  
      window.addEventListener('scroll', onScroll);
      return () => window.removeEventListener('scroll', onScroll);
    }, [hasBeenInView]);
    
    const isBike = ad && ad.Type === 'bike'
    const hasAdAreaData = Object.keys(adAreaData).length !== 0;
    const adCreatedDate = isBike && ad.Seller ? ad.Seller.CreatedDate : adAreaData && adAreaData.CreatedDate

    return (
        hasAdAreaData || isBike ? 
            <S.Container>
                <S.Title>Conquistas</S.Title>
                <S.ConquistasContainer ref={targetRef} respondsFast={adAreaData && adAreaData.ResponseTime}>
                    <S.ConquistaItem id='AdAreaLifeTime'>
                        <S.Image src='/assets/img/SellerArea/existence-time.png' alt='Tempo de de existência' />
                        <span>
                            Desde <strong>{setFormatDateMonthYear(adCreatedDate)}</strong> na Webmotors
                        </span>
                    </S.ConquistaItem>
                    {ad.Type === 'car' && (
                        <Fragment>
                            {
                                adAreaData.CountAds && 
                                    <S.ConquistaItem id='AdAreaCountAds'>
                                        <S.Image src='/assets/img/SellerArea/number-ads.png' alt='Quantidade de anúncios' />
                                        <span>
                                            Anunciou <strong>{adAreaData.CountAds}</strong> vezes na Webmotors
                                        </span>
                                    </S.ConquistaItem>
                            }
                            {
                              adAreaData.ResponseTime && 
                                    <S.ConquistaItem id='AdAreaCountResponseTime'>
                                        <S.Image src='/assets/img/SellerArea/response-time.png' alt='Tempo de resposta' />
                                        <span>
                                            Responde em até <strong>{adAreaData.AverageTime}</strong> {adAreaData.AverageTime > 1 ? 'horas' : 'hora'}
                                        </span>
                                    </S.ConquistaItem>  
                            }
                        </Fragment>
                    )}
                </S.ConquistasContainer>
            </S.Container> 
        : null 
    );
}

SellerAchievements.propTypes = {
    adArea: PropTypes.shape({
        ResponseTime: PropTypes.bool,
        CreatedDate: PropTypes.string,
        CountAds: PropTypes.number,
        AverageTime: PropTypes.number
    }),
    ad: PropTypes.object
};

SellerAchievements.defaultProps = {
    adArea: {}
};

export default SellerAchievements;
